import React, { Component } from 'react';
import { Container, TextField, Typography } from '@mui/material';
import Telasight from '../../assets/images/telasight.png';
import { Button } from '@lexcelon/react-util';
import { requestConsultation } from '../../api';
import { setSuccess, setError, clearErrors } from '../../alerts';

class Consult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      name: '',
      email: '',
      phoneNumber: '',
      comments: '',
      success: false
    };
  }

  componentWillUnmount() {
    clearErrors();
  }

  onSubmit = (e) => {
    e.preventDefault();
    
    this.setState({ isLoading: true });
    const { name, email, phoneNumber, comments } = this.state;
    requestConsultation({ name, email, phoneNumber, comments: comments === '' ? undefined : comments }).then(() => {
      setSuccess('Successfully sent consultation request');
      this.setState({ isLoading: false, success: true });
    }).catch(error => {
      setError(error ?? 'Failed to send consultation request. Please try again.');
      this.setState({ isLoading: false });
    });
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    return (
      <Container style={{ paddingTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }} center>
        <Typography variant='h1' style={{ textAlign: 'center', marginTop: '1em' }}>Consult a Parasitologist</Typography>

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={Telasight} alt='Telasight logo' style={{ width: '600px', objectFit: 'contain' }} />
        </div>

        <Typography variant='h2' style={{ textAlign: 'center' }} gutterBottom>Request a Consultation</Typography>

        {this.state.success ? (
          <Typography variant='body1' style={{ textAlign: 'center', fontSize: 20 }}>Thank you for your request. We will contact you within the next 24 hours.</Typography>
        ) : (
          <form onSubmit={this.onSubmit}>

            {/* Name */}
            <TextField
              required
              name='name'
              label='Name'
              value={this.state.name}
              onChange={this.onChange}
              variant='filled'
              disabled={this.state.isLoading}
              style={{ width: '100%', marginBottom: '0.5em' }}
            />

            {/* Email */}
            <TextField
              required
              name='email'
              label='Email'
              type='email'
              value={this.state.email}
              onChange={this.onChange}
              variant='filled'
              disabled={this.state.isLoading}
              style={{ width: '100%', marginBottom: '0.5em' }}
            />

            {/* Phone Number */}
            <TextField
              required
              name='phoneNumber'
              label='Phone Number'
              type='tel'
              value={this.state.phoneNumber}
              onChange={this.onChange}
              variant='filled'
              disabled={this.state.isLoading}
              style={{ width: '100%', marginBottom: '0.5em' }}
            />

            {/* Comments */}
            <TextField
              name='comments'
              label='Comments (include test ID, if applicable)'
              value={this.state.comments}
              onChange={this.onChange}
              variant='filled'
              multiline
              rows={4}
              disabled={this.state.isLoading}
              style={{ width: '100%', marginBottom: '0.5em' }}
            />

            <Button
              type='submit'
              isLoading={this.state.isLoading}
              style={{ width: '100%', marginTop: '1em' }}
            >
              Submit
            </Button>
          </form>
        )}
        
      </Container>
    );
  }
}

Consult.propTypes = {
};

export default Consult;
